import { useTranslation } from "react-i18next";
import React, { useEffect, useState, useRef } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface BreakdownRow {
  category: string;
  volume: string;
  share: string;
  change: string;
  isSubItem?: boolean;
  isTotal?: boolean;
}
interface BreakdownTableProps {
  rows: BreakdownRow[];
}
type PivotOption = '3DS outcome' | 'Card brand' | 'Card country' | 'Card type' | 'Currency' | 'CVC response' | 'Input method' | 'Interaction type' | 'Network token status' | 'Postal code response' | 'Retry status';
export function BreakdownTable({
  rows
}: BreakdownTableProps) {
  const {
    t
  } = useTranslation("analytics");
  const [pivotBy, setPivotBy] = useState<PivotOption>('Card type');
  const [showPivotDropdown, setShowPivotDropdown] = useState(false);
  const pivotRef = useRef<HTMLDivElement>(null);
  const pivotOptions: PivotOption[] = ['3DS outcome', 'Card brand', 'Card country', 'Card type', 'Currency', 'CVC response', 'Input method', 'Interaction type', 'Network token status', 'Postal code response', 'Retry status'];

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (pivotRef.current && !pivotRef.current.contains(event.target as Node)) {
        setShowPivotDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1516">
      <div className="flex items-center gap-2 mb-4" data-id="element-1517">
        <span className="text-sm text-gray-700" data-id="element-1518">{t("components.CardPaymentsBreakdown.pivot_by")}</span>
        <div className="relative" ref={pivotRef} data-id="element-1519">
          <button onClick={() => setShowPivotDropdown(!showPivotDropdown)} className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-gray-900 bg-white border border-gray-300 rounded-lg hover:bg-gray-50" data-id="element-1520">
            
            <span data-id="element-1521">{pivotBy}</span>
            <ChevronDownIcon size={16} data-id="element-1522" />
          </button>

          {showPivotDropdown && <div className="absolute left-0 mt-2 w-64 bg-white rounded-lg shadow-xl border border-gray-200 py-2 z-50 max-h-80 overflow-y-auto" data-id="element-1523">
              {pivotOptions.map(option => <button key={option} onClick={() => {
            setPivotBy(option);
            setShowPivotDropdown(false);
          }} className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-50 flex items-center justify-between ${pivotBy === option ? 'text-gray-900 font-medium' : 'text-gray-700'}`} data-id="element-1524">
              
                  <span data-id="element-1525">{option}</span>
                  {pivotBy === option && <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="text-blue-600" data-id="element-1526">
                
                      <path d="M13.5 4.5L6 12L2.5 8.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1527" />
                
                    </svg>}
                </button>)}
            </div>}
        </div>
      </div>

      <table className="w-full" data-id="element-1528">
        <thead data-id="element-1529">
          <tr className="border-b border-gray-200" data-id="element-1530">
            <th className="text-left text-sm font-medium text-gray-700 pb-3" data-id="element-1531">
              {t("components.BreakdownTable.category")}
            </th>
            <th className="text-right text-sm font-medium text-gray-700 pb-3" data-id="element-1532">
              {t("components.CardPaymentsBreakdown.payment_volume")}
            </th>
            <th className="text-right text-sm font-medium text-gray-700 pb-3" data-id="element-1533">
              {t("components.BreakdownTable.share_of_volume")}
            </th>
            <th className="text-right text-sm font-medium text-gray-700 pb-3" data-id="element-1534">
              {t("components.BreakdownTable.change")}
            </th>
          </tr>
        </thead>
        <tbody data-id="element-1535">
          {rows.map((row, index) => <tr key={index} className={row.isTotal ? 'border-t-2 border-gray-300' : 'border-b border-gray-200'} data-id="element-1536">
            
              <td className={`py-3 text-sm ${row.isTotal ? 'font-semibold text-gray-900' : row.isSubItem ? 'text-gray-600 pl-6' : 'font-medium text-gray-900'}`} data-id="element-1537">
              
                {row.category}
              </td>
              <td className={`py-3 text-sm text-right ${row.isTotal ? 'font-semibold text-gray-900' : row.isSubItem ? 'text-gray-600' : 'text-gray-900'}`} data-id="element-1538">
              
                {row.volume}
              </td>
              <td className={`py-3 text-sm text-right ${row.isTotal ? 'font-semibold text-gray-900' : row.isSubItem ? 'text-gray-600' : 'text-gray-900'}`} data-id="element-1539">
              
                {row.share}
              </td>
              <td className={`py-3 text-sm text-right ${row.change.startsWith('-') ? 'text-red-600' : row.change.startsWith('+') ? 'text-green-600' : ''}`} data-id="element-1540">
              
                {row.change}
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}